module.exports = __webpack_public_path__ + "e47f8aac12f5b503c3c9569330a26fb6.svg";